export const EMPTY_SELECTION = ""
export const LOADING_OPTION_VALUE = "__loading_options"
